import React from 'react';

import { MonthList } from 'modules/shared/utils';
import { readCMSValue, getDefault } from 'modules/shared-cms/utils';

import { CtaButton, HtmlContainer } from 'modules/shared-ui/components';
import {
    CarouselFilterBloc,
    TitleBloc,
    LabelTitleContainer,
    RibbonBlocContainer,
    CustomerBlocContainer,
} from 'modules/shared-cms-advanced/components';

import { TripLandingProps } from './trip-landing-type';

import enhancer from './trip-landing-enhancer';

import styles from './trip-landing-page.module.css';

const tripLandingPage: React.FC<TripLandingProps> = React.memo((props: TripLandingProps) => {
    const {
        carouselFilterTitle,
        carouselFilterTextColor,
        destinations,
        color1,
        color2,
        ctaLink1,
        ctaLink2,
        ctaStyle1,
        ctaStyle2,
        width1,
        width2,
        ctaText1,
        ctaText2,
        ctaLink12,
        ctaLink22,
        ctaStyle12,
        ctaStyle22,
        ctaText12,
        ctaText22,
        cta2Link,
        cta2Text,
        cta2Style,
        ctaText,
        horizontalPosition1,
        horizontalPosition2,
        justification1,
        justification2,
        picture1,
        picture2,
        subtitle1,
        subTitle2,
        textColor1,
        textColor2,
        title1,
        title2,
        tagline1,
        tagline2,
        mentions,
        ...rest
    } = props;

    return (
        <React.Fragment>
            <div className={`${styles.root}`}>
                <div className={styles.titleBlocSection}>
                    <TitleBloc
                        title={title1}
                        subTitle={subtitle1}
                        tagline={tagline1}
                        width={width1}
                        textColor={textColor1}
                        picture={picture1}
                        color={color1}
                        ctaLink={ctaLink1}
                        ctaText={ctaText1}
                        ctaStyle={ctaStyle1}
                        ctaLink2={ctaLink12}
                        ctaText2={ctaText12}
                        ctaStyle2={ctaStyle12}
                        horizontalPosition={horizontalPosition1}
                        justification={justification1}
                    />
                </div>

                <div className={styles.carouselContainer}>
                    <CarouselFilterBloc
                        title={carouselFilterTitle}
                        textColor={carouselFilterTextColor}
                        items={destinations}
                        filterValues={MonthList}
                    />
                </div>

                {picture2 ? (
                    <div className={styles.titleBlocContainer}>
                        <TitleBloc
                            title={title2}
                            subTitle={subTitle2}
                            tagline={tagline2}
                            width={width2}
                            textColor={textColor2}
                            picture={picture2}
                            color={color2}
                            ctaLink={ctaLink2}
                            ctaText={ctaText2}
                            ctaStyle={ctaStyle2}
                            ctaLink2={ctaLink22}
                            ctaText2={ctaText22}
                            ctaStyle2={ctaStyle22}
                            horizontalPosition={horizontalPosition2}
                            justification={justification2}
                        />
                    </div>
                ) : (
                    ''
                )}

                <div className={styles.labelTitleContainer}>
                    <LabelTitleContainer {...rest} />
                </div>

                {readCMSValue(ctaText) ? (
                    <div className={styles.ctaContainer}>
                        <CtaButton ctaText={ctaText} {...rest} />
                    </div>
                ) : (
                    ''
                )}

                <div className={styles.ribbonContainer}>
                    <RibbonBlocContainer {...rest} />
                </div>

                {readCMSValue(cta2Text) ? (
                    <div className={styles.ctaContainer}>
                        <CtaButton
                            ctaText={getDefault(readCMSValue(cta2Text), '')}
                            ctaLink={readCMSValue(cta2Link)}
                            ctaStyle={readCMSValue(cta2Style)}
                        />
                    </div>
                ) : (
                    ''
                )}

                <CustomerBlocContainer {...rest} />

                {mentions && (
                    <div className={styles.mentionsContainer}>
                        <HtmlContainer htmlContent={getDefault(readCMSValue(mentions), '')} />
                    </div>
                )}
            </div>
        </React.Fragment>
    );
});

export const TripLandingPage = enhancer(tripLandingPage);
